<template>
  <v-dialog v-model="dialog" scrollable max-width="400px" persistent v-if="trip">
    <v-form>
      <v-card>
        <v-toolbar color="white" fixed>
          <h3>{{ $i18n.t(label) }}</h3>
        </v-toolbar>
        <v-card-text>
          <v-container dense>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="trip.startKm" :label="$i18n.t('Start KM')" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="trip.endKm" :label="$i18n.t('Stop KM')" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="trip.dutySlipNo" :label="$i18n.t('Ref No')"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small>{{ $i18n.t("* indicates required field") }}</small>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog(false)">Close</v-btn>
          <v-btn color="success darken-1" @click="save()" :loading="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost } from "@/store/common/module/apis";

@Component({
  name: "DutyClose",
  props: {
    trip: {
      default: null,
    },
    label: {
      default: "Duty Close",
    },
    showDialog: {
      default: false,
    },
  },
})
export default class DutyClose extends Vue {
  dialog = false;

  get loading() {
    return common.loading;
  }

  async save() {
    common.setLoading(true);
    try {
      await doPost(`/api/trip/${this.trip._id}/deploy`, this.trip);
      common.setLoading(false);
      common.showMessage("Duty closed");
      this.closeDialog(true);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.showMessage);
    }
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog(reload) {
    this.dialog = false;
    this.$emit("dutyCloseDilogClose", reload);
  }
}
</script>
